import { InboundShipmentStatus } from "common/clients/inbound/InboundShipment/InboundShipmentStatus";

export const isInboundShipmentDraftStatus = (inboundStatus: InboundShipmentStatus) =>
  [
    InboundShipmentStatus.NEED_PACKAGE_DETAILS,
    InboundShipmentStatus.PACKAGES_ADDED,
    InboundShipmentStatus.PACKAGES_FINAL,
  ].includes(inboundStatus);
